import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSliderDelete = createAsyncThunk(
    'sliderGet/fetchSliderDelete',
    async ({ id }) => {
        const response = await SliderDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const sliderDeleteSlice = createSlice({
    name: 'sliderDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderDeleteSlice.reducer;
